<template>
    <header v-if="!is_mini_game && (!template_html || template_html.header_default_enable)"
            :class="{'header-main':!isLmsHeader,'header-mobile':isMobile,'header-logged':logged || isGuest, 'header-minigame': isMiniGameHeader}"
>
        <div v-if="isLmsHeader && ($route.name!=='Campaign' || $route.name!=='CampaignOperator')" class="menu logged">
            <div>
                <LmsHeader />
                <VT v-if="store_vt" id="vt" ref="vt" />
            </div>
        </div>
        <div v-else-if="$route.name==='Campaign' || $route.name==='CampaignOperator'">
        </div>
        <div v-else class="header-content">
<!--            <div v-if="isMiniGameHeader">-->
<!--                <span class="session-name">{{ sessionName }}</span>-->
<!--            </div>-->
            <div class="header-logo">
                <img :src="logo" alt="logo" @click="logoClick">
            </div>
            <div v-if="!logged && !isGuest" class="header-buttons">
                <LangDropDown v-if="langActive" class="header-icon" :class="{langDropDownMobile:isMobile}" :with_text="isMobile" />
<!--                login signup-->
                <div v-if="loginSinupActive" class="login-signup">
                    <button class="ui button primary" @click="loginHandler">{{ $t('home.login') }}</button>
                    <button class="ui button secondary" @click="signupHandler">{{ $t('home.cadastrese') }}</button>
                </div>
                <button v-if="showGuest" class="ui button primary" @click="guestHandler">{{ $t('home.entrarVisitante') }}</button>
                <div v-if="!loginSinupActive && loginSocial" class="d-flex gap-2 align-items-center justify-content-center">
                    <span :style="{color:'var(--buttons_color)'}">{{this.$i18n.t('home.logarCom')}}</span>
                    <component v-for="(item,index) in loginSocial" :key="index" :is="item" origin="home" />
                </div>
            </div>
            <div v-else class="header-buttons">
<!--                select using flags-->
                <BtnPromotional class="not-mobile" />
                <LangDropDown v-if="langActive" class="header-icon not-mobile" />
                <div v-if="musicActive" class="header-icon color-font not-mobile"
                     data-position="bottom center" :data-tooltip="descs.radio"
                     @click="playPause()"
                     v-html="audio_active?header_buttons.radio_on_button:header_buttons.radio_off_button" />
                <div v-if="is_streamer" class="header-icon not-mobile" data-position="bottom center" :data-tooltip="descs.lives" @click="link('Lives')">
                    <svg class="svg-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path d="M39.384615 374.153846c0 114.215385 45.292308 222.523077 126.03077 303.261539 17.723077 17.723077 43.323077 17.723077 61.046153 0 17.723077-17.723077 17.723077-45.292308 0-63.015385-63.015385-63.015385-98.461538-149.661538-98.461538-240.246154s35.446154-177.230769 98.461538-240.246154c17.723077-17.723077 17.723077-45.292308 0-63.015384-17.723077-17.723077-43.323077-17.723077-61.046153 0C84.676923 151.630769 39.384615 259.938462 39.384615 374.153846z m250.092308 177.230769c17.723077 17.723077 45.292308 17.723077 63.015385 0 17.723077-17.723077 17.723077-45.292308 0-63.015384-29.538462-29.538462-47.261538-70.892308-47.261539-114.215385 0-43.323077 15.753846-82.707692 47.261539-114.215384 17.723077-17.723077 17.723077-45.292308 0-63.015385-17.723077-17.723077-45.292308-17.723077-63.015385 0-47.261538 47.261538-72.861538 110.276923-72.861538 177.230769 0 66.953846 25.6 129.969231 72.861538 177.230769zM856.615385 70.892308c-17.723077-17.723077-45.292308-17.723077-63.015385 0-17.723077 17.723077-17.723077 45.292308 0 63.015384 63.015385 63.015385 100.430769 149.661538 100.430769 240.246154s-35.446154 177.230769-100.430769 240.246154c-17.723077 17.723077-17.723077 45.292308 0 63.015385 17.723077 17.723077 45.292308 17.723077 63.015385 0 80.738462-80.738462 126.030769-189.046154 126.030769-303.261539 0-114.215385-45.292308-222.523077-126.030769-303.261538zM805.415385 374.153846c-1.969231-66.953846-27.569231-129.969231-74.83077-177.230769-17.723077-17.723077-43.323077-17.723077-61.046153 0-17.723077 17.723077-17.723077 45.292308 0 63.015385 29.538462 31.507692 47.261538 70.892308 47.261538 114.215384 0 43.323077-17.723077 84.676923-47.261538 114.215385-17.723077 17.723077-17.723077 45.292308 0 63.015384 17.723077 17.723077 43.323077 17.723077 61.046153 0 47.261538-47.261538 72.861538-110.276923 72.861539-177.230769zM466.707692 480.492308c-43.323077-17.723077-70.892308-59.076923-70.892307-108.307693 0-63.015385 51.2-114.215385 114.215384-114.215384 63.015385 0 116.184615 51.2 116.184616 114.215384 0 49.230769-29.538462 88.615385-70.892308 106.338462v464.738461c0 11.815385-11.815385 23.630769-23.630769 21.661539h-43.323077c-11.815385 0-21.661538-9.846154-21.661539-21.661539V480.492308z" fill="var(--fonts_color)"/>
                    </svg>
                </div>
                <div v-if="isModerator" class="header-icon not-mobile" @click="moderatorHandler('Group')">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                        <path stroke-width="2" fill="var(--fonts_color)" d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"/>
                    </svg>
                </div>
                <div v-if="phoneActive" class="header-icon not-mobile" data-position="bottom center" :data-tooltip="descs.menu" @click="phoneHandler" v-html="header_buttons.menu_button"/>
                <div v-if="supportActive" class="header-icon not-mobile" data-position="bottom center" :data-tooltip="descs.help" @click="link('Support')" v-html="header_buttons.help_button" />
                <Oracle v-if="false" id="oracle" ref="oracle" />
                <VT v-if="cartActive && store_vt" id="vt" ref="vt" />
                <Vtex v-if="cartActive && store_vtex" id="vtex" ref="vtex" />
<!--                user photo open dropdown-->
                <div ref="dropdown-menu-header" class="dropdown-menu-header ui inline suidropdown">
                    <div v-if="!isMobile && !isGuest" class="text">
                        <img v-if="avatar_metaverse && use_avatar" :src="avatar_metaverse" alt="Avatar">
                        <img v-else-if="user_picture && !use_avatar" :src="user_picture" alt="Avatar">
                        <img v-else src="assets/icons/myPerfil/avatar.svg" alt="Avatar">
                        <i class="dropdown icon" />
                    </div>
                    <div v-else class="text">
                        <i class="bars icon" />
                    </div>
                    <div class="menu menu-main">
                        <div class="ui grid">
                            <div v-if="isGuest" class="sixteen wide column profile justify-content-center">
                                <div class="flex-1" v-if="showGuest && loginSinupActive">
                                    <span @click="signupHandler" data-position="bottom center" :data-tooltip="descs.guest">
                                        <p class="text-nickname">{{ this.$i18n.t('guest.criarConta') }}</p>
                                    </span>
                                </div>
                                <i v-if="isMobile" class="close icon" @click="closeMenuMain" />
                            </div>
                            <div v-else class="sixteen wide column profile">
                                <img @click="profileHandler" v-if="avatar_metaverse && use_avatar" :src="avatar_metaverse" alt="Avatar">
                                <img @click="profileHandler" v-else-if="user_picture && !use_avatar" :src="user_picture" alt="Avatar">
                                <img @click="profileHandler" v-else src="assets/icons/myPerfil/avatar.svg" alt="Avatar">
                                <div class="flex-1">
                                    <span @click="profileHandler" class="name">{{ name }}</span>
                                    <span @click="profileHandler" class="nickname">@{{ nickname }}</span>
                                </div>
                                <i v-if="isMobile" class="close icon" @click.prevent.stop="closeMenuMain" />
                            </div>
                            <div class="sixteen wide column">
<!--                                points  and coins-->
                                <div class="d-flex gap-3">
                                    <div v-if="pointsActive"
                                         class="header-icon"
                                         :class="{clickable:pointsClick,'cursor-default':!pointsClick }"
                                         data-position="bottom center" :data-tooltip="descs.points"
                                         @click="pointsHandler" >
                                        <div v-html="header_buttons.points_button" />
                                        <span v-if="isMiniGameHeader">{{ getMinigameScore }}</span>
                                        <span v-else>{{ TotalPoints }}</span>
                                    </div>
                                    <div v-if="coinsActive"
                                         class="header-icon"
                                         :class="{clickable:coinsClick,'cursor-default':!coinsClick}"
                                         @click="coinsHandler" >
                                        <div v-html="header_buttons.coins_button" />
                                        <span>{{ TotalCoins }}</span>
                                    </div>
                                    <div v-if="badgesActive"
                                         class="header-icon clickable"
                                         data-position="bottom center" :data-tooltip="descs.badges"
                                         @click="link('Badges')" >
                                        <div v-html="header_buttons.badges_button" />
                                        <span>{{ TotalBadges }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ui divider w-100" />
                        <div class="d-flex gap-3 menu-lang mb-3">
                            <LangDropDown v-if="langActive" with_text class="header-icon" />
                            <div v-if="musicActive" class="header-icon color-font"
                                 data-position="bottom center" :data-tooltip="descs.radio"
                                 @click="playPause()"
                                 v-html="audio_active?header_buttons.radio_on_button:header_buttons.radio_off_button" />
                            <div v-if="supportActive" class="header-icon color-font" data-position="bottom center" :data-tooltip="descs.help" @click="link('Support')" v-html="header_buttons.help_button" />
                        </div>
                        <div class="items">
                            <div v-if="!isGuest && profileActive" class="item header-icon" @click="profileHandler()">
                                <div v-html="header_buttons.profile_button"/>
                                <span>{{ $t('lms.header.profile') }}</span>
                            </div>
                            <div v-if="cameraActive" class="item header-icon" @click="cameraHandler()">
                                <div v-html="header_buttons.camera_button" />
                                <span>{{ $t('lms.header.selfies') }}</span>
                            </div>
                            <div v-if="libraryActive" class="item header-icon" @click="libraryHandler()">
                                <div v-html="header_buttons.library_button" />
                                <span>{{ $t('lms.header.library') }}</span>
                            </div>
                            <div v-if="friendsActive" class="item header-icon" @click="link('Friends')">
                                <div v-html="header_buttons.friends_button" />
                                <span>{{ $t('lms.header.friends') }}</span>
                            </div>
                            <div v-if="phoneActive" class="item header-icon" @click="phoneHandler">
                                <div v-html="header_buttons.menu_button"/>
                                <span>{{ $t('lms.header.phone_menu') }}</span>
                            </div>
                            <div v-if="notificationsActive" class="item header-icon" @click="notificationsHandler()">
                                <div v-html="header_buttons.notification_button" />
                                <div>
                                    <span>{{ $t('lms.header.notifications') }}</span>
                                    <span v-if="$app.notifications_count>0" class="notification_count">{{$app.notifications_count}}</span>
                                </div>
                            </div>
                            <div v-if="paymentsActive" class="item header-icon" @click="link('Payments')">
                                <div v-html="header_buttons.coins_button" />
                                <span>{{ $t('lms.header.payments') }}</span>
                            </div>
                            <div v-if="cartActive" class="item header-icon" @click="cartHandler()">
                                <div v-html="header_buttons.cart_button" />
                                <span>{{ $t('lms.header.cart') }}</span>
                            </div>
                            <div v-if="isModerator" class="item header-icon" @click="moderatorHandler('Group')">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                    <path stroke-width="2" fill="var(--fonts_color)" d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"/>
                                </svg>
                                <span>{{ $t('lms.header.group') }}</span>
                            </div>
                            <div v-if="isModerator" class="item header-icon" @click="moderatorHandler('Slides')">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.3125 21.3125V2.6875H2.6875V21.3125H21.3125ZM21.3125 0C22.0208 0 22.6458 0.270833 23.1875 0.8125C23.7292 1.35417 24 1.97917 24 2.6875V21.3125C24 22.0208 23.7292 22.6458 23.1875 23.1875C22.6458 23.7292 22.0208 24 21.3125 24H2.6875C1.97917 24 1.35417 23.7292 0.8125 23.1875C0.270833 22.6458 0 22.0208 0 21.3125V2.6875C0 1.97917 0.270833 1.35417 0.8125 0.8125C1.35417 0.270833 1.97917 0 2.6875 0H21.3125ZM9.3125 6.6875L16 12L9.3125 17.3125V6.6875Z" fill="var(--buttons_color)"/>
                                </svg>
                                <span>
                                {{ $t('lms.header.slides') }}
                            </span>
                            </div>
                            <div v-if="supportActive" class="item header-icon" @click="link('Support')">
                                <div v-html="header_buttons.help_button" />
                                <span>{{ $t('lms.header.faq') }}</span>
                            </div>

                            <div v-if="policyActive" class="item header-icon" @click="$router.push({ path: '/termos/accept_policy' })">
                                <!-- <div v-html="header_buttons.profile_button"/> -->
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 0.820343L15.5 4.17972V9.17972C15.5 10.3256 15.3047 11.4453 14.9141 12.5391C14.5495 13.6068 14.0286 14.5964 13.3516 15.5078C12.6745 16.4193 11.8802 17.2006 10.9688 17.8516C10.0573 18.4766 9.06771 18.9193 8 19.1797C6.93229 18.9193 5.94271 18.4766 5.03125 17.8516C4.11979 17.2006 3.32552 16.4193 2.64844 15.5078C1.97135 14.5964 1.4375 13.6068 1.04688 12.5391C0.682292 11.4453 0.5 10.3256 0.5 9.17972V4.17972L8 0.820343ZM7.17969 5.82034V7.50003H8.82031V5.82034H7.17969ZM7.17969 9.17972V14.1797H8.82031V9.17972H7.17969Z" fill="#05B1EB"/>
                                </svg>

                                <span>{{ $t('app.politica') }}</span>
                            </div>
                            <div v-if="termsActive" class="item header-icon" @click="$router.push({ path: '/termos/accept_terms' })">
                                <!-- <div v-html="header_buttons.profile_button"/> -->
                                <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.67969 0.679718L13.6797 5.67972V15.6797C13.6797 16.1224 13.5104 16.5131 13.1719 16.8516C12.8594 17.1641 12.4688 17.3203 12 17.3203H2C1.53125 17.3203 1.1276 17.1641 0.789062 16.8516C0.476562 16.5131 0.320312 16.1224 0.320312 15.6797L0.359375 2.32034C0.359375 1.87763 0.515625 1.50003 0.828125 1.18753C1.14062 0.848989 1.53125 0.679718 2 0.679718H8.67969ZM6.10156 14L10.8281 9.27347L9.65625 8.10159L6.10156 11.6563L4.34375 9.85941L3.17188 11.0313L6.10156 14ZM7.82031 6.50003H12.4297L7.82031 1.92972V6.50003Z" fill="#05B1EB"/>
                                </svg>

                                <span>{{ $t('signup.termosECondicoesTitle') }}</span>
                            </div>


                            <div class="item header-icon" @click="logoutHandler()">
                                <div v-html="header_buttons.logoff_button" />
                                <span>{{ $t('lms.header.logout') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <audio ref="song" src="/assets/music/blx1-liger.mp3"/>
    </header>
</template>
<script>
import {mapGetters} from "vuex";
import LmsHeader from "@/components/lms/components/LmsHeader.vue";
import LangDropDown from "@/components/LangDropDown.vue";
import BtnPromotional from "@/components/Notifications/BtnPromotional.vue";
import LoginAzure from "@/components/login/LoginAzure.vue";
import LoginFacebook from "@/components/login/LoginFacebook.vue";
import LoginGoogle from "@/components/login/LoginGoogle.vue";
import logoDefault from "@/assets/img/loading.gif";
import Oracle from "@/components/oracle/Oracle";
import VT from "@/components/vt/VT.vue";
import Vtex from "@/components/vtex/Vtex.vue";
let emitter = require('tiny-emitter/instance');

export default {
    components: {
        Oracle,
        Vtex,
        VT,
        LangDropDown,
        LmsHeader,
        BtnPromotional,
        LoginAzure,
        LoginFacebook,
        LoginGoogle,
    },
    data() {
        return {
            audio_active: false,
            play: true,
            songIndex: 0,
            sessionName: ''
        }
    },
    computed:{
        ...mapGetters([
            'logged', 'isGuest', 'switch', 'header_buttons',
            'LibraryName', 'radio', 'is_mini_game','design','points',
            'is_streamer','user_type', 'smartphone_options', 'store_vt', 'store_vtex',
            'avatar_metaverse', 'use_avatar', 'user_picture', 'name',
            'nickname','TotalCoins','TotalPoints','TotalBadges','LibraryName', 'isMiniGameHeader', 'current_session'
        ]),
        ...mapGetters("LMS", ["isLms"]),
        ...mapGetters({
            template_html: 'TemplateHTML/getHTMLTemplate',
        }),
        ...mapGetters("Minigames", ["getMinigameScore"]),
        isMobile(){
            return this.$store.getters.isMobile && this.$app.windowWidth < 1000;
        },
        showGuest() {
            return Boolean(this.switch.guest_mode);
        },
        loginSinupActive(){
            return this.switch.login_signup;
        },
        descs(){
            return {
                "badges": this.$i18n.t('app.vejaSeusBadges'),
                "guest": this.$i18n.t('guest.criarContaDescription'),
                "logo": this.$i18n.t('app.voltarAoMapa'),
                "nick": this.$i18n.t('app.editeSuaConta'),
                "points": this.$i18n.t('app.vejaSuaPosicao'),
                "coin": this.$i18n.t('app.customizeSeuAvatar'),
                "selfie": this.$i18n.t('app.tireSelfies'),
                "noti": this.$i18n.t('app.leiaNotificacoes'),
                "menu": this.$i18n.t('app.menuDeNavegacoes'),
                "radio": this.$i18n.t('app.radio'),
                "shutoff": this.$i18n.t('app.fazerLogout'),
                "guestShutoff": this.$i18n.t('guest.fazerLogout'),
                "help": this.$i18n.t('app.ajudaEContato'),
                "conteudo": this.$i18n.t('app.conteudo'),
                "lives": this.$i18n.t('app.lives')
            }
        },
        logo() {
            return this.$app.eventlogo || this.design?.logo || this.$app.getCookie("design_logo") || logoDefault;
        },
        langActive(){
            return this.switch.multilanguages && this.switch.active_languages;
        },
        musicActive(){
            return this.radio && this.switch.radio && this.switch.event_menu && this.switch.event_menu['radio'];
        },
        pointsActive(){
            return this.switch.event_menu && this.switch.event_menu['score_pontos'] &&
                this.switch.Habilitar_Pontos && this.switch.points_on_header;
        },
        coinsActive(){
            return this.switch.event_menu && this.switch.event_menu['score_moedas'] &&
                this.switch.Habilitar_Moedas && this.switch.coins_on_header;
        },
        badgesActive(){
            return this.switch.enable_badge_counter;
        },
        pointsClick(){
            return this.switch.event_menu && this.switch.event_menu['ranking_pontos'] &&
                this.switch.Habilitar_Ranking;
        },
        coinsClick(){
            return this.switch.finance_profile_menu;
        },
        notificationsActive(){
            return this.switch.event_menu && this.switch.event_menu && this.switch.event_menu['notificacoes'];
        },
        libraryActive(){
            return this.LibraryName && this.LibraryName.length>0 && this.switch.event_menu && this.switch.event_menu['biblioteca'];
        },
        cameraActive(){
            return (this.switch.event_menu && this.switch.event_menu['camera']) && (this.switch.Habilitar_Selfies || this.switch.selfies_blog);
        },
        profileActive(){
            return this.switch.event_menu && this.switch.event_menu['profile'];
        },
        friendsActive(){
            return this.switch.event_menu && this.switch.event_menu['amigos']&&
                this.switch.Habilitar_Amigos;
        },
        phoneActive(){
            return this.smartphone_options && this.switch.event_menu && this.switch.event_menu['navegacao'];
        },
        paymentsActive(){
            return this.switch.event_menu && this.switch.event_menu['financeiro'];
        },
        cartActive(){
            return this.switch.event_menu && this.switch.event_menu['cart'] && (this.store_vt || this.store_vtex);
        },
        supportActive(){
            return this.switch.event_menu && this.switch.event_menu['faq'];
        },
        policyActive(){
            return this.switch.event_menu && this.switch.event_menu['politica_privacidade'];
        },
        termsActive(){
            return this.switch.event_menu && this.switch.event_menu['termos_uso'];
        },
        loginSocial(){
            let loginSocial = false;
            if (!this.loginSinupActive) {
                let logins = {
                    Login_Google: 'LoginGoogle',
                    Login_Facebook: 'LoginFacebook',
                    Login_Azure: 'LoginAzure',
                }
                for (let key in logins) {
                    if (this.switch[key]) {
                        if (!loginSocial)
                            loginSocial = {}
                        loginSocial[key] = logins[key];
                        break;
                    }
                }
            }
            return loginSocial;
        },
        isModerator(){
            return this.user_type==='moderator';
        },
        isLmsHeader(){
            return (this.logged || this.isGuest) && this.isLms;
        }
    },
    beforeMount() {
        this.sessionName = localStorage.getItem('session_name');
    },
    mounted() {
        this.$nextTick(() => {
            this.init();
        });
        const root = this;
        this.$refs['song'].addEventListener('ended', function () {
            root.play = true;
            root.audio_active = false;
            root.playPause();
        });
    },
    updated() {
        this.init();
    },
    beforeDestroy() {
        this.destroy();
    },
    methods: {
        playPause() {
            if (this.play) {
                // songIndex=Math.floor((Math.random() * songs.length) );
                if (!this.audio_active) {
                    this.$refs['song'].src = this.radio[this.songIndex];
                    this.$refs['song'].play();
                    this.$refs['song'].volume = 1;
                    this.play = false;
                    this.audio_active = true;
                    this.songIndex++
                    if (this.songIndex == this.radio.length) {
                        this.songIndex = 0
                    }
                    return;
                }
            }
            this.$refs['song'].pause();
            this.audio_active = false;
            this.play = true;
        },
        logoClick() {
            if (this.logged || this.isGuest){
                this.closeMenuMain();
                this.$app.mobileClose();
                this.$app.redirectToMap();
            }else if (!this.$app.access_before_start.includes(this.$route.name) && this.$app.access_logged.includes(this.$route.name)){
                this.link('Home');
            }
        },
        phoneHandler(){
            this.closeMenuMain();
            this.$app.notification = false;
            this.$app.camera = false;
            this.$app.$refs['mobile'].mobileHandler();
        },
        link(link){
            this.closeMenuMain();
            this.$app.link(link);
        },
        closeMenuMain(){
            if (this.$refs['dropdown-menu-header'])
                window.$(this.$refs['dropdown-menu-header']).suidropdown('hide');
        },
        coinsHandler(){
            if (this.coinsClick) {
                this.closeMenuMain();
                this.$app.openPackage();
            }
        },
        pointsHandler(){
            if(this.isMiniGameHeader) {
                // Show ranking as a modal
                emitter.emit('Minigames::ranking::modal', true);
            } else
            if (this.pointsClick) {
                this.exitLocal(this.pointsExit)
            }
        },
        signupHandler(){
            this.closeMenuMain();
            this.$app.$refs.SignupModal.openModal(true)
        },
        loginHandler(){
            this.closeMenuMain();
            this.$app.$refs.LoginModal.openModal(true);
        },
        guestHandler(){
            this.closeMenuMain();
            this.$app.createGuestVerifyCaptcha()
        },
        profileHandler(){
            this.exitLocal(this.profileExit)
        },
        logoutHandler(){
            this.closeMenuMain();
            this.$app.logout();
        },
        cartHandler(){
            if (this.store_vt) {
                this.$refs.vt.cart=true;
            } else if (this.store_vtex) {
                this.$refs.vtex.cart=true;
            }
        },
        cameraHandler(){
            this.$app.openSelfieModal();
        },
        notificationsHandler(){
            this.$app.camera = false;
            this.$app.notifications_count = 0;
            this.$app.getNotifications();
            this.$app.mobileClose();
        },
        libraryHandler(){
            this.$app.camera = false;
            this.$app.notification = false;
            this.$app.conteudoHandler();
            this.$app.mobileClose();
        },
        moderatorHandler(type){
            this.$app.moderatorHandler(type);
        },
        pointsExit(value) {
            if (value == 1) {
                if (this.switch.event_menu && this.switch.event_menu['ranking_pontos']) {
                    this.link("Ranking");
                    this.$app.iframecomponent = false;
                }
            }
        },
        profileExit(value) {
            if (value == 1) {
                console.log({
                    "route":this.$route,
                })
                if (this.$route.name == 'Profile' && this.$route.params.userId ) {
                    this.$router.push({name: 'Profile'});
                } else if (this.$route.name != 'Profile') {
                    this.link("Profile");
                }
                this.$app.iframecomponent = false;
            }
        },
        exitLocal(response) {
            if (this.$app.iframecomponent) {
                this.$app.modal(
                    "confirmation",
                    this.$i18n.t('app.atencao'),
                    this.$i18n.t('app.desejaRealmente'),
                    response,
                    this.$i18n.t('app.sim'),
                    this.$i18n.t('app.nao')
                );
            } else {
                response(1);
            }
        },
        init(){
            let headers_height = "75px";
            if (this.isMobile && !this.isGuest && !this.logged) {
                headers_height = "150px";
            }
            if (this.is_mini_game){
                headers_height = "0px";
            }
            document.documentElement.style.setProperty('--headers_height', headers_height);
            if (this.$refs['dropdown-menu-header']) {
                window.$(this.$refs['dropdown-menu-header']).suidropdown({
                    action: 'hide',
                    displayType:'flex',
                });
            }
            // Check if it is Lms
            if (this.$route.fullPath.includes("/lms/")) {
                this.$store.dispatch('LMS/enableIsLMS')
            } else {
                this.$store.dispatch('LMS/disableLms')
            }
        },
        destroy(){
            window.$(this.$refs['dropdown-menu-header']).suidropdown('destroy');
        },
    }
}
</script>
<style lang="scss">
    .header-main {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0;
        height: var(--headers_height);
        min-height: var(--headers_height);
        background-color: var(--headers_color);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        z-index: 997;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        .ui.button{
            padding: .75rem 2rem;
            border-radius: 10px;
            min-width: 200px;
            &.primary{
                background-color: var(--buttons_color);
                color: var(--fonts_color);
                &:hover{
                    background-color: var(--buttons_color_hover);
                    color: var(--fonts_color);
                }
            }
            &.secondary{
                background-color: var(--buttons_color_2nd);
                color: var(--fonts_color_2nd);
                &:hover{
                    background-color: var(buttons_color_2nd_hover);
                    color: var(--fonts_color_2nd);
                }
            }
        }
        &.header-logged {
            background-color: var(--headers_color_logged);
        }
        .login-signup{
            display: flex;
            gap: 1rem;
        }
        &.header-mobile{
            &:not(.header-logged){
                height: auto;
                .header-content{
                    height: 100%;
                    flex-direction: column;
                    .header-logo{
                        max-width: 95%;
                        height: 50px;//33% of 150px "--headers_height" mobile
                        margin-top: 15px;
                        img{
                            height: 100%;
                            width: 100%;
                        }
                    }
                    .header-buttons{
                        max-width: 95%;
                        margin-top: 10px;
                        margin-bottom: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: .75rem;
                        flex-wrap: wrap;
                        .langDropDownMobile{
                            width: 100%;
                            height: 40px;
                            justify-content: space-between;
                        }
                        .login-signup{
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 10px;
                            .ui.button {
                                padding: 0.85rem 1rem;
                                border-radius: 10px;
                                min-width: 125px;
                                width: calc(50% - 5px);
                                margin: 0;
                            }
                        }
                        .ui.button {
                            padding: 0.85rem 1rem;
                            border-radius: 10px;
                            min-width: 125px;
                        }
                    }

                    .session-name {
                        font-family: Exo, sans-serif;
                        font-weight: 600;
                        font-size: 19px;
                        line-height: 25px;
                        color: #FFFFFF;
                    }
                }
            }
            .not-mobile{
                display: none!important;
            }
            .cart-controller-header{
                display: none!important;
            }
            .header-content .header-buttons .dropdown-menu-header {
                .menu-main {
                    width: 100vw !important;
                    height: 100vh !important;
                    top: 0 !important;
                    left: 0 !important;
                    position: fixed;
                    margin: 0;
                    border-radius: 0;
                    max-height: 100vh;
                    flex-direction: column;
                    .profile{
                        .close{
                            position: absolute;
                            top: 1rem;
                            right: 1rem;
                            cursor: pointer;
                            font-size: 1.5rem;
                            color: var(--fonts_color);
                        }

                    }
                }
            }
        }
        .header-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            max-width: 87.5%;
            margin: 0 auto;
            height: 75%;
            .header-logo {
                height: 100%;
                max-width: 50%;
                img {
                    height: 100%;
                    width: 100%;
                    cursor: pointer;
                    object-fit: contain;
                }
            }
            .header-buttons {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                height: 100%;
                max-width: 50%;
                gap: 1rem;
                .items{
                    overflow-x: hidden;
                    overflow-y: auto;
                    scrollbar-color: var(--buttons_color) var(--headers_color_logged);
                    scrollbar-width: thin;
                    >.item{
                        position: relative;
                        cursor: pointer;
                        border: none;
                        height: auto;
                        min-height: 2.57142857rem;
                        text-align: left;
                        border-top: none;
                        line-height: 1em;
                        font-size: 1rem;
                        padding: .78571429rem 1.14285714rem;
                        text-transform: none;
                        font-weight: 400;
                        box-shadow: none;
                        -webkit-touch-callout: none;
                    }
                }
                .header-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    svg {
                        width: 1.5rem;
                        height: 1.5rem;
                        fill: var(--fonts_color);
                    }
                }
                .dropdown-menu-header{
                    height: 70%;
                    >.text{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: .25rem;
                        height: 100%;
                        >img{
                            margin: 0;
                            width: 2.5rem;
                            height: 2.5rem;
                            max-height: 2.5rem;
                            border-radius: 50%;
                            object-fit: cover;
                            box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
                        }
                        .icon{
                            color: var(--fonts_color) !important;
                        }
                    }
                    .menu-main{
                        padding: 1.5rem;
                        border-radius: 1rem;
                        background-color: var(--headers_color_logged);
                        width: min(100vw,300px);
                        min-width: auto;
                        height: auto!important;
                        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
                        border-color: transparent;
                        max-height: calc(100vh - 100% - 3rem);
                        flex-direction: column;
                        >.divider{
                            margin: 1rem 0;
                            border-top: 1px solid var(--fonts_color);
                            border-bottom: none;
                            opacity: .5;
                        }
                        .text-nickname{
                            font-size: 1rem!important;
                            font-weight: 700;
                            color: var(--fonts_color);
                        }
                        .profile{
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            gap: .5rem;
                            img{
                                margin: 0;
                                border-radius: 50%;
                                height: 4rem;
                                width: 4rem;
                                object-fit: cover;
                                box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
                            }
                            .flex-1{
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                justify-content: center;
                                gap: .25rem;
                                max-width: calc(100% - 4.5rem);
                                .name{
                                    font-size: 1.25rem;
                                    font-weight: 700;
                                    color: var(--fonts_color);
                                    max-width: 100%;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                                .nickname{
                                    margin: 0;
                                    font-size: 1rem;
                                    font-weight: 400;
                                    color: var(--fonts_color);
                                    max-width: 100%;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                            }
                        }
                        .lang_dropdown{
                            border: 1px solid var(--fonts_color);
                            padding: 0;
                            border-radius: 0.625rem;
                        }
                        .header-icon{
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            gap: .5rem;
                            &.color-font{
                                svg{
                                    fill: var(--fonts_color);
                                    path{
                                        fill: var(--fonts_color);
                                    }
                                }
                            }
                            svg{
                                width: 1.5rem;
                                height: 1.5rem;
                                fill: var(--buttons_color);
                                path{
                                    fill: var(--buttons_color);
                                }
                            }
                            span{
                                font-size: 1.25rem;
                                font-weight: 400;
                                color: var(--fonts_color);
                            }
                        }
                        >.item{
                            background-color: transparent;
                            color: var(--fonts_color);
                            border-radius: 0.625rem;
                            &.selected{
                                background: transparent;
                                color: var(--fonts_color);
                            }
                            &:hover{
                                background: rgba(var(--buttons_color-r),var(--buttons_color-g),var(--buttons_color-b),.1);
                                color: var(--fonts_color);
                            }
                        }
                        .notification_count{
                            display: inline-block;
                            text-align: center;
                            margin-left: .5rem;
                            height: 1.5rem;
                            width: 1.5rem;
                            border-radius: 50%;
                            background-color: var(--buttons_color);
                            color: var(--fonts_color);
                            font-size: 1rem!important;
                            line-height: 1.5rem;
                            font-weight: 400;
                        }
                    }
                    .clickable{
                        cursor: pointer;
                    }
                    .cursor-default{
                        cursor: default;
                        .header-icon{
                            cursor: default;
                        }
                    }
                }
            }
        }

        &.header-minigame {
            //background-color: #59A5B5 !important;
            //.session-name {
            //    font-family: Exo, sans-serif;
            //    font-weight: 600;
            //    font-size: 19px;
            //    line-height: 25px;
            //    color: #FFFFFF;
            //}
        }
    }
</style>